import { AssessmentType } from '../types';
import { ActionType, createReducer } from 'typesafe-actions';
import * as actions from './actions';

type AssessmentsActions = ActionType<typeof actions>;

const initialState: AssessmentType = {
  data: null,
  filter: null,
  page: 0,
  size: 30,
  assessmentLoadingType: '',
};

const reducer = createReducer<AssessmentType, AssessmentsActions>(
  initialState
).handleAction(actions.setAssessmentsData, (state, { payload }) => ({
  ...state,
  data: payload.data,
  filter: payload.filter,
  page: payload.page,
  size: payload.size,
  assessmentLoadingType: payload.assessmentLoadingType,
}));

export default reducer;
